export default {
  apiKey: "AIzaSyASL8uLQOjsTFN1yXc2XgcAXCGQKvwuk08",
  authDomain: "push-notifications-2c763.firebaseapp.com",
  databaseURL: "https://push-notifications-2c763.firebaseio.com",
  storageBucket: "push-notifications-2c763.appspot.com",
  messagingSenderId: "352210000767"
}



// WEBPACK FOOTER //
// ./src/config/auth.js